var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"title-type"},_vm._l((_vm.cptTitleData),function(item,index){return _c('title-cell',{key:index,attrs:{"item":item,"index":index}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--1!./node_modules/vue-loader/lib??vue-loader-options!./src/components/tariff/title-type/index.vue?vue&type=template&id=29e3d286&scoped=true
// module id = null
// module chunks = 